<template>
    <transition name="fade">
        <div class="loading">
            <div class="bk"></div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'FullLoading'
}
</script>

<style lang="less" scoped>
@import 'global.less';
.loading {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0px;
    left: 0px;
    z-index: 999;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
}
@r: 5px;
.bk {
    border: @r solid @main-color;
    border-right: @r solid #fff;
    border-bottom: @r solid #fff;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    animation: loading 1s infinite linear;
}
@keyframes loading {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/FullLoading.vue